import { URLUtils } from 'src/app/urlUtils';
import { HttpService } from 'src/app/services/http.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LeavepageComponent } from '../leavepage/leavepage.component';
import { GeneralleavepageComponent } from 'src/app/matter/genaralmatter/creategeneralmatter/generalleavepage/generalleavepage.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatterService } from './../../../matter.service';
import { take } from 'rxjs';
import { HostListener } from '@angular/core';

@Component({
    selector: 'matter-team-members',
    templateUrl: 'matter-team-members.component.html',
    styleUrls: ['matter-team-members.component.scss'],
    standalone: false
})
export class MatterTeamMembersComponent {
    
    @Output() selectedTmsEvent: EventEmitter<any> = new EventEmitter();
    @Input() data: any = {};
    @Input() teammembers: any = {};
    @Input() groups: any[] = [];
    @Input() clients: any = {};
    // @Input() tmGrp:any ={}
    @Output() tmsSaved = new EventEmitter<boolean>();
    groupName:any;
    @Input() matterId: any;
    
    teammembersList: any = [];
    selectedTeammembers: any = [];
    searchText: any = '';
    ownerName:any;
    filteredData:any;
    //@Input()grouplist:any=[]
    isSelectAllVisible = true;
    showAllItems = false;
    pathName: string = "legalmatter";
    product = environment.product;
    originalClientsList:any[]=[];
    isMarketplace = false;
    tmPayload: any;
    mattername: any;
    isCreate = false;
    editMatter: any;
    editGroupIds: any = [];
    isEdit: boolean = false;
    @Input() tmsWereSaved:any;
    role:any;
    removedTmIds: number[] = [];
    editeMatterInfo: any;
    loggedUserId: string = '';
        
    originalClientIds: number[] = [];
    hasNewClientsAdded = false;

    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload(event: BeforeUnloadEvent) {
        if (this.hasNewClientsAdded) {
            event.preventDefault();
            event.returnValue = ''; // to show warning
        }
    }

    constructor(private httpservice: HttpService,private dialog: MatDialog, private router: Router, public toast: ToastrService, private matterService: MatterService) { }

    ngOnInit() {
        // console.log('data in tm:', this.data);
        // console.log('data', this.data)
        // console.log('matterId', this.matterId)
        // console.log('selected tm', this.selectedTeammembers)
        // console.log('teammm', this.teammembers)
        // console.log('tlist', this.teammembersList)
        // console.log('get tmsWereSaved',this.tmsWereSaved)
        const isEditRoute = window.location.pathname.includes('edit');
        if(!isEditRoute && this.tmsWereSaved === false){
            this.teammembers = [];
        }
        else{
            this.selectedTeammembers = this.teammembers;
        }
         
        this.loggedUserId = localStorage.getItem('user_id') || '';

        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        const path = window.location.pathname;

        if (path.indexOf("updateTeams") > -1) {
            if (path.includes("legal")) {
                this.isCreate = !this.isCreate;
                this.matterService.editLegalMatterObservable.subscribe((result: any) => {
                    this.editMatter = result;
                    this.mattername = result;
                    this.editGroupIds = result.groups;
                    this.isEdit = true;

                    // Store original client IDs
                    this.originalClientIds = (result.members || []).map((c: any) => c.id);
                });
            }
            else if (path.includes("general")) {
                this.isCreate = !this.isCreate;
                this.matterService.editGeneralMatterObservable.subscribe((result: any) => {
                    this.editMatter = result;
                    this.mattername = result;
                    this.editGroupIds = result.groups;
                    this.isEdit = true;
                    
                    // Store original client IDs
                    this.originalClientIds = (result.members || []).map((c: any) => c.id);
                });
            }
        }

        //console.log('matterId',this.matterId)
        this.ownerName=localStorage.getItem('name');
        this.getTeammembers();
        // console.log('ng tm', this.teammembers);

        
         if (window.location.pathname.indexOf("edit") > -1) {
                this.matterService.editLegalMatterObservable.pipe(take(1)).subscribe((result: any) => {
                    if (!result) return;

                    this.isEdit = true;
                    this.matterId = result.id;
                    this.editeMatterInfo = result;

                    // build selectedTeammembers FIRST
                    const members = result.members || [];
                    const owner = result?.owner;
                    const ordered: any[] = [];
                    // console.log('owner:', owner);
                    if (owner) ordered.push(owner);

                    members.forEach((m: any) => {
                        if (!ordered.find(o => o.id === m.id)) {
                        ordered.push(m);
                        }
                    });
                    //console.log('ordered members:', ordered);

                    this.selectedTeammembers = ordered;

                    // NOW load TM list
                    this.loadTeamMembers();
                });

                 this.matterService.editGeneralMatterObservable.pipe(take(1)).subscribe((result: any) => {
                    if (!result) return;

                    this.isEdit = true;
                    this.matterId = result.id;
                    this.editeMatterInfo = result;

                    // build selectedTeammembers FIRST
                    const members = result.members || [];
                    const owner = result?.owner;
                    const ordered: any[] = [];
                    // console.log('owner:', owner);
                    if (owner) ordered.push(owner);

                    members.forEach((m: any) => {
                        if (!ordered.find(o => o.id === m.id)) {
                        ordered.push(m);
                        }
                    });
                    //console.log('ordered members:', ordered);

                    this.selectedTeammembers = ordered;

                    // NOW load TM list
                    this.loadTeamMembers();
                });

       }
         else {
              this.loadTeamMembers();
            }
  
         this.groupName = this.clients.map((obj: any) => obj?.name);
    }

    loadTeamMembers() {
  if (this.product === 'corporate') {
    this.getCorpTeammembers();
  } else {
    this.role = localStorage.getItem("role");
    if (this.role === 'GH') {
      this.getGHTm();
    } else {
      this.getTm();
    }
  }
}


   getTm() {
  this.httpservice.sendGetRequest(URLUtils.getMembers).subscribe((res: any) => {

    this.teammembersList = res.data.users.filter((user: any) =>
      !user.groups?.some(
        (grp: any) => grp.name === 'SuperUser' || grp.name === 'AAM'
      )
    );

    this.originalClientsList = [...this.teammembersList];

    // remove owner
    const index = this.teammembersList.findIndex(
      (d: any) => d.name === this.ownerName
    );
    if (index > -1) {
      this.teammembersList.splice(index, 1);
    }

    // ✅ APPLY ONLY IN EDIT
    if (this.isEdit && this.selectedTeammembers?.length > 0) {

      const selectedIds = new Set(
        this.selectedTeammembers.map((m: any) => m.id)
      );

      this.teammembersList = this.teammembersList.filter(
        (tm: any) => !selectedIds.has(tm.id)
      );

      this.originalClientsList = [...this.teammembersList];
    }

    // checkbox handling (unchanged)
    const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    if (checkbox) {
      checkbox.checked =
        this.teammembersList.length === 0 && this.isEdit;
    }

  });
}

    getGHTm() {
        let gh = { module: "matter" };
        this.httpservice.sendGetRequest(URLUtils.getMembers, gh).subscribe((res: any) => {
            //this.teammembersList = res.data.users;
            //console.log('members',this.teammembersList)

            // this.teammembersList = res.data.users;
            this.teammembersList = res.data.users.filter((user: any) =>
                !user.groups?.some(
                    (grp: any) => grp.name === 'SuperUser' || grp.name === 'AAM'
                )
            );
            //console.log('viewIt', this.teammembersList)

            this.originalClientsList = this.teammembersList;
            let index = this.teammembersList.findIndex((d: any) => d.name === this.ownerName); //find index in your array
            if (index > -1) {
                this.teammembersList.splice(index, 1); //to remove the owner name in 1st index
            }
            if (this.teammembers && this.teammembers.length > 0) {
                // this.selectedTeammembers = [...this.teammembers];
                // let res = this.teammembersList.filter((el: any) => {
                //     return !this.selectedTeammembers.find((element: any) => {
                //         return element.id === el.id;
                //     });
                // });
                // this.teammembersList = res


                this.selectedTeammembers = this.teammembers.filter((group: any) =>
                    this.teammembersList.some((g: any) => g.id === group.id)
                );
                //console.log('Updated teammembersList:', this.selectedTeammembers);
                this.teammembersList = this.teammembersList.filter(
                    (group: any) => !this.selectedTeammembers.some((selected: any) => selected.id === group.id)
                );
                this.originalClientsList = [...this.teammembersList];
            }
            if (this.selectedTeammembers.length == 0) {
                let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                if (checkbox != null)
                    checkbox.checked = false;
            }
            if (this.teammembersList.length === 0) {
                let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                if (checkbox != null)
                    checkbox.checked = true;
            }


        })
    }
    getTeammembers() {
        this.groupName = this.groups.map((obj: any) => obj.name);
        // console.log('grp',this.groupName)
        let grps = this.groups.map((obj: any) => obj.id);
        //console.log('grp', grps);

        let clientId = this.clients
            .filter((obj: any) => obj.client_id)
            .map((obj: any) => obj.client_id);
        
        let clients = this.clients.map((client: any) => ({
            id: client.id,
            type: client.type
        }));

        // const payload = {
        //     group_acls: grps,
        //     clients: clients,
        //     attachment_type: 'members'
        // };

        const is_marketplace_string = localStorage.getItem("is_marketplace");
        const isTemp = localStorage.getItem("isTemp");

        if (is_marketplace_string === 'true') {
            this.isMarketplace = true;
            this.tmPayload = {
                group_acls: grps,
                attachment_type: 'members'
            };
        }
        else if (isTemp === 'true' && clientId.length > 0) {
            this.tmPayload = {
                group_acls: grps,
                clients: clients,
                attachment_type: 'members'
            };
        }
        else if (isTemp === 'true') {
            this.tmPayload = {
                group_acls: grps,
                attachment_type: 'members'
            };
        }
        else {
            this.tmPayload = {
                group_acls: grps,
                clients: clients,
                attachment_type: 'members'
            };
        }

        this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, this.tmPayload).subscribe(
            (res: any) => {
                //console.log('tm res',res)
                if (!res['error'] && res['members']?.length > 0){
                    this.teammembersList = res['members'];
                    this.originalClientsList = this.teammembersList;
                    let index = this.teammembersList.findIndex((d: any) => d.name === this.ownerName); //find index in your array
                    if (index > -1) {
                        this.teammembersList.splice(index, 1); //to remove the owner name in 1st index
                    }
                    if (this.teammembers && this.teammembers.length > 0) {
                        // this.selectedTeammembers = [...this.teammembers];
                        // let res = this.teammembersList.filter((el: any) => {
                        //     return !this.selectedTeammembers.find((element: any) => {
                        //         return element.id === el.id;
                        //     });
                        // });
                        // this.teammembersList = res
                        this.selectedTeammembers = this.teammembers.filter((group: any) =>
                            this.teammembersList.some((g: any) => g.id === group.id)
                        );
                        //console.log('Updated teammembersList:', this.selectedTeammembers);
                        this.teammembersList = this.teammembersList.filter(
                            (group: any) => !this.selectedTeammembers.some((selected: any) => selected.id === group.id)
                        );
                        this.originalClientsList = [...this.teammembersList];
                    }
                    if (this.selectedTeammembers.length == 0) {
                        let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                        if (checkbox != null)
                          checkbox.checked = false;
                      }
                    if (this.teammembersList.length === 0) {
                        let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                        if (checkbox != null)
                            checkbox.checked = true;
                    }
                }
        })
    }

    getCorpTeammembers() {
        this.groupName = this.groups.map((obj: any) => obj.name);
        //console.log('grp',this.groupName)
        let grps = this.groups.map((obj: any) => obj.id);
        this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, { 'group_acls': grps, 'attachment_type': 'members' }).subscribe(
            (res: any) => {

                this.selectedTeammembers = [];
                this.teammembersList = res['members'];
                this.originalClientsList = this.teammembersList;
                let index = this.teammembersList.findIndex((d: any) => d.name === this.ownerName); //find index in your array
                if (index > -1) {
                    this.teammembersList.splice(index, 1); //to remove the owner name in 1st index
                }
                if (this.teammembers && this.teammembers.length > 0) {
                    this.teammembers.forEach((client: any) => {
                        const matchedClient = this.teammembersList.find((el: any) => el.id === client.id);
                        if (matchedClient) {
                            this.selectedTeammembers.push(matchedClient);
                        }
                    });
                    // Filter the clientsList to remove already selected clients
                    this.teammembersList = this.teammembersList.filter((el: any) => {
                        return !this.selectedTeammembers.find((selectedClient: any) => selectedClient.id === el.id);
                    });
                }
                if (this.selectedTeammembers.length == 0) {
                    let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                    if (checkbox != null)
                        checkbox.checked = false;
                }
            })
    }

    selectAll(event: any) {
        if (event?.target?.checked) {
            if (this.teammembersList?.length > 0) {
                // if(this.filteredData?.length>0){
                //     this.selectedTeammembers = this.selectedTeammembers.concat(this.teammembersList);
                //     this.teammembersList = this.teammembersList.filter((el: any) => {
                //       return !this.selectedTeammembers.find((element: any) => {
                //         return element.id === el.id;
                //       });
                //     });
                //   }
                //   else{
                // this.selectedTeammembers = this.selectedTeammembers.concat(this.teammembersList);
                // this.teammembersList = [];
                //   }
                const filteredClients = this.teammembersList.filter((client: any) =>
                client.name.toLowerCase().includes(this.searchText.toLowerCase())
              );
              if (filteredClients?.length > 0) {
                this.selectedTeammembers = this.selectedTeammembers.concat(filteredClients);
                this.teammembersList = this.teammembersList.filter((el: any) => {
                  return !this.selectedTeammembers.find((element: any) => {
                    return element.id === el.id;
                  });
                });
              }
              else {
                this.teammembersList = this.selectedTeammembers.concat(this.teammembersList);
                this.selectedTeammembers = [];
              }
            }
        } else {
            this.teammembersList = this.selectedTeammembers.concat(this.teammembersList);
            this.selectedTeammembers = [];
        }
        this.searchText = '';
        this.httpservice.setTms(this.selectedTeammembers); //observing the selectedTms
    }
    // selectTeammember(group: any, value?: any) {
    //     this.selectedTeammembers.push(group);
    //     let index = this.teammembersList.findIndex((d: any) => d.id === group.id); //find index in your array
    //     this.teammembersList.splice(index, 1);
    //     if (this.teammembersList.length==0) {
    //         let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //         if (checkbox != null)
    //           checkbox.checked = true;
    //       }
    //     //this.searchText = '';
    // }

        //new code
    //     selectTeammember(client: any, isChecked: boolean) {
    //   this.isSelectAllVisible = true;

    //   if (isChecked) {
    //     // ✅ Selecting team member
    //     this.selectedTeammembers.push(client);

    //     // VERY IMPORTANT: unmark removal if previously removed
    //     this.removedTmIds = this.removedTmIds.filter(
    //       id => id !== client.id
    //     );

    //     const index = this.teammembersList.findIndex(
    //       (d: any) => d.id === client.id
    //     );
    //     if (index !== -1) {
    //       this.teammembersList.splice(index, 1);
    //     }

    //   } else {
    //     //  Unselecting team member
    //     const index = this.selectedTeammembers.findIndex(
    //       (d: any) => d.id === client.id
    //     );

    //     if (index !== -1) {
    //       this.selectedTeammembers.splice(index, 1);
    //       this.teammembersList.push(client);

    //       //  mark for removal (save-controlled)
    //       if (!this.removedTmIds.includes(client.id)) {
    //         this.removedTmIds.push(client.id);
    //       }
    //     }
    //   }

    //   if (this.teammembersList.length === 0) {
    //     const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //     if (checkbox) checkbox.checked = true;
    //   }

    //   this.httpservice.setTms(this.selectedTeammembers);
    // }

    // selectTeammember(client: any, isChecked?: any) {  
    //     this.isSelectAllVisible = true;  
        
    //     if (isChecked) {
    //         //  prevent duplicate add
    //         if (!this.isExists(this.selectedTeammembers, client.id)) {
    //             this.selectedTeammembers.push(client);
    //         }

    //       this.selectedTeammembers.push(client);
    //         // VERY IMPORTANT: unmark removal if previously removed
    //         this.removedTmIds = this.removedTmIds.filter(
    //             id => id !== client.id
    //         );

    //       let index = this.teammembersList.findIndex((d: any) => d.id === client.id); // Find index in your array
    //       if (index !== -1) {
    //         this.teammembersList.splice(index, 1);
    //       }
    //     } else {
    //       // Handle unselecting a single client
    //       let index = this.selectedTeammembers.findIndex((d: any) => d.id === client.id);
    //       if (index !== -1) {
    //         this.selectedTeammembers.splice(index, 1);
    //         this.teammembersList.push(client);
    //       }
    //     }
    
    //     if (this.teammembersList.length == 0) {
    //       let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //       if (checkbox != null) {
    //         checkbox.checked = true;
    //       }
    //     }
    //     this.httpservice.setTms(this.selectedTeammembers); //observing the selectedTms
    //   }

    // removeTeammember(group: any) {  
    //     // mark client for removal
    //     if (!this.removedTmIds.includes(group.id)) {
    //         this.removedTmIds.push(group.id);
    //     }
    //     // console.log('Marked for removal:', this.removedTmIds);

    //     // let index = this.selectedTeammembers.findIndex((d: any) => d.id === group.id); //find index in your array
    //     // this.selectedTeammembers.splice(index, 1);
    //     this.teammembersList.push(group);
        
    //     this.httpservice.setTms(this.selectedTeammembers);

    //     // if (this.selectedTeammembers.length == 0 || this.teammembersList.length==1) {
    //     //     let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //     //     if (checkbox != null)
    //     //         checkbox.checked = false;
    //     // }
    // }

    private recomputeDirtyState() {
        const currentIds = this.selectedTeammembers.map((m: any) => m.id);
        this.hasNewClientsAdded = currentIds.some(
            (id: any) => !this.originalClientIds.includes(id)
        );
    }

    selectTeammember(client: any, isChecked: boolean) {
        this.isSelectAllVisible = true;

        if (isChecked) {

            //  prevent duplicate add
            if (!this.isExists(this.selectedTeammembers, client.id)) {
                this.selectedTeammembers.push(client);
            }

            // unmark removal
            this.removedTmIds = this.removedTmIds.filter(id => id !== client.id);

            // remove from available list
            this.teammembersList = this.teammembersList.filter(
                (tm: any) => tm.id !== client.id
            );

        } else {
            // unselect
            this.selectedTeammembers = this.selectedTeammembers.filter(
                (tm: any) => tm.id !== client.id
            );

            // add back to list if not exists
            if (!this.isExists(this.teammembersList, client.id)) {
                this.teammembersList.push(client);
            }
        }

        // Check if this client was NOT in original list
        this.recomputeDirtyState();

        this.httpservice.setTms(this.selectedTeammembers);
    }

    get filteredTeamMembers() {
        const search = this.searchText?.toLowerCase() || '';

        const selectedIds = new Set(this.selectedTeammembers.map((m: any) => m.id));

        return this.teammembersList.filter((tm: any) =>
            !selectedIds.has(tm.id) &&
            tm.name.toLowerCase().includes(search)
        );
    }
    
    removeTeammember(member: any) {
        // mark for removal
        if (!this.removedTmIds.includes(member.id)) {
            this.removedTmIds.push(member.id);
        }

        //  REMOVE from selected list (THIS WAS MISSING)
        this.selectedTeammembers = this.selectedTeammembers.filter(
            (tm: any) => tm.id !== member.id
        );

        // add back to available list safely
        if (!this.isExists(this.teammembersList, member.id)) {
            this.teammembersList.push(member);
        }

        // Recalculate: are there still any new clients?
        this.recomputeDirtyState();
        
        this.httpservice.setTms(this.selectedTeammembers);
    }
    
    isExists(list: any[], id: any): boolean {
        return list.some(item => item.id === id);
    }

    saveTeammembers() {
        //console.log('sectm',this.selectedTeammembers)

        // Apply removals ONLY when saving
        this.removedTmIds.forEach((id) => {
            let index = this.selectedTeammembers.findIndex(
                (d: any) => d.id === id
            );
            if (index > -1) {
                this.selectedTeammembers.splice(index, 1);
            }
        });
        this.removedTmIds = []; // Clear queue after save

        // let tms = this.selectedTeammembers.filter((element: any) => element)
        //     .map((c: any) => ({
        //         id: c.id
        //     }));
        let ownerId = this.editeMatterInfo?.owner?.id;


       let tms = this.selectedTeammembers
           .filter((element: any) => element && element.id !== ownerId)
           .map((c: any) => ({id: c.id}));
        //console.log('payload:', tms);
        let URL = URLUtils.patchLegalMatter(this.matterId);
        if(this.data.type === "general"){
            URL = URLUtils.patchGeneralMatter(this.matterId);
        }
        this.httpservice.sendPatchRequest(URL, { "members": tms }).subscribe((res: any) => {
            // if (!res.error)
            //     this.toast.success('Team Member(S) saved successfully!');
            // else if (res.error)
            //     this.toast.error(res.msg)
              
            this.httpservice.setTms(this.selectedTeammembers); //observing the selectedTms
        }, (error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
                const errorMessage = error.error.msg || 'Unauthorized';
                this.toast.error(errorMessage);
                //console.log(error);
            }
        })

        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        //console.log('pathname', this.pathName)
        let cancel = localStorage.getItem('oncancel');
        if (cancel) {
            localStorage.removeItem('oncancel');
            this.router.navigate([`/matter/${this.pathName}/view`]);
            return;
        }

        this.selectedTmsEvent.emit(this.selectedTeammembers);
        this.tmsSaved.emit(true);
    }
    OnSaveLater() {
        localStorage.setItem('oncancel', "oncancel");
        // this.teammembersList = this.teammembersList.concat(this.selectedTeammembers);
        // this.selectedTeammembers = [];
        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        if (this.selectedTeammembers.length === 0 || this.selectedTeammembers.length > 0) {
            this.saveTeammembers();
            // if(this.pathName === "legalmatter"){
            //     this.dialog.open(LeavepageComponent, {
            //         width: '350px',  // Set the width here
            //         height: '180px',
            //         hasBackdrop: true,
            //         panelClass: 'hello',
            //         disableClose: true
            //     });
            //     return;
            //     }
            //     else if(this.pathName === "generalmatter"){
            //         this.dialog.open(GeneralleavepageComponent, {
            //             width: '350px',  // Set the width here
            //             height: '180px',
            //             hasBackdrop: true,
            //             panelClass: 'hello',
            //             disableClose: true
            //         });
            //         return; 
            //     }
            //     else{}
        }
        const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox) {
            checkbox.checked = false;
        }
    }
        
    OnCancel() {
        localStorage.setItem('oncancel', "oncancel");
        // this.teammembersList = this.teammembersList.concat(this.selectedTeammembers);
        // this.selectedTeammembers = [];
        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        if (this.selectedTeammembers.length > 0) {
            //this.saveTeammembers();
            if(this.pathName === "legalmatter"){
                this.dialog.open(LeavepageComponent, {
                    width: '350px',  // Set the width here
                    height: '180px',
                    hasBackdrop: true,
                    panelClass: 'hello',
                    disableClose: true
                });
                return;
                }
                else if(this.pathName === "generalmatter"){
                    this.dialog.open(GeneralleavepageComponent, {
                        width: '350px',  // Set the width here
                        height: '180px',
                        hasBackdrop: true,
                        panelClass: 'hello',
                        disableClose: true
                    });
                    return; 
                }
                else{}
        }
        else {
            this.router.navigate([`/matter/${this.pathName}/view`]);
        }
        const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox) {
            checkbox.checked = false;
        }
    }

    // keyup(){
    //     if(this.searchText == ' ')
    //     this.searchText=this.searchText.replace(/\s/g, "");
    //     this.filteredData = this.teammembersList.filter((item:any) =>item.name.toLocaleLowerCase().includes(this.searchText));
    //     let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //     if (checkbox != null)
    //       checkbox.checked = false;
    //   }
    keyup() {
        if (this.searchText == ' ') {
            this.searchText = this.searchText.replace(/\s/g, '');
        }
        // this.filteredData = this.teammembersList.filter((item: any) => item.name.toLocaleLowerCase().includes(this.searchText));
        const searchLower = this.searchText.toLowerCase();
        this.filteredData = this.teammembersList.filter((item: any) => item.name.toLowerCase().includes(searchLower));
        this.filteredData = this.originalClientsList.filter((item: any) =>
            item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()) &&
            !this.selectedTeammembers.includes(item)
        );

        // Update visibility based on the filtered data
        this.isSelectAllVisible = this.teammembersList.length > 0;

        let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox != null) {
            checkbox.checked = false;
        }
    }
      truncateString(text: string): string {
        if (text.length > 25) {
          return text.slice(0, 25) + '...';
        }
        return text;
    }
    // Function to toggle the view state
    toggleView() {
        this.showAllItems = !this.showAllItems;
    }

}
